import { Component, OnInit ,ViewChild} from '@angular/core';
import { reconciliationService } from '../../../../service/reconciliations-service';
import { TreeTable } from 'primeng/treetable';
import * as XLSX from 'xlsx';
import { DatePipe } from '@angular/common';
import { ReconciliationSearchDTO } from '../../../../models/reconciliationSearchDTO';

interface Column {
  field: string;
  header: string;
}
@Component({
  selector: 'app-view-reconciliation',
  templateUrl: './view-reconciliation.component.html',
  styleUrl: './view-reconciliation.component.scss'
})
export class ViewReconciliationComponent implements OnInit {

  @ViewChild('tt') tt?: TreeTable;

  cols!: Column[];
  getReconciliationsList!: any[];
  getReconciliationsStoreList!: any[];
  totalDebit: number = 0;
  totalCredit: number = 0;
  totalBalance: number = 0;
  rows:number=5;
  limit:number=10;
  currentPage:number=1
  totalRecords:number=0
  startDate!: Date
  endDate!: Date
  isLoading: boolean = false;
  filteredData: any[] = [];
  reconciliationSearchDTO?:ReconciliationSearchDTO
  constructor(
    private reconciliations:reconciliationService,
    private datePipe: DatePipe
  ) {
    this.reconciliationSearchDTO = new ReconciliationSearchDTO()
  }

  ngOnInit(): void {

    this.cols = [
      { field: 'vendor_code', header: 'Vendor Code' },
      { field: 'ty', header: 'TY' },
      { field: 'doc_no', header: 'Doc No' },
      { field: 'post_date', header: 'Post Date' },
      { field: 'bill_no', header: 'Bill No' },
      { field: 'bill_date', header: 'Bill Date' },
      { field: 'assignment', header: 'Assignment' },
      { field: 'debit', header: 'Debit' },
      { field: 'credit', header: 'Credit' },
      { field: 'balance', header: 'Balance' },
      { field: 'description', header: 'Description' },
  ];
  this.get_reconciliation()

  }

  get_reconciliation(){
    let data={
      page:this.currentPage,
      limit:this.limit,
      reconciliation_search_dto:this.reconciliationSearchDTO
      }
    this.isLoading=true
    this.reconciliations.getReconciliationLists(data).then((response)=>{
      this.isLoading=false
      this.getReconciliationsList = response.message.reconciliation_list
      this.getReconciliationsStoreList = response.message.reconciliation_list
      this.totalRecords = response.message.total_reconciliation
      this.calculateTotals();
    }).catch((error)=>{
      this.isLoading=false
      console.log(error)
    })
  }

  onPageChange(event:any){
    this.currentPage=event.page + 1
    this.limit=event.rows
    this.get_reconciliation()
  }

  onInputChange(event: any, field: string) {
    const inputValue = (event.target as HTMLInputElement)?.value;
    if (this.reconciliationSearchDTO && field) {
      (this.reconciliationSearchDTO as any)[field] = inputValue;
    }
    this.currentPage
    this.get_reconciliation()
    // this.tt?.filter(inputValue, field, 'contains');
    this.calculateTotals();
  }

  filterByDateRange() {
    if (this.startDate && this.endDate) {
      const formattedStartDate = this.formatDate(this.startDate);
      const formattedEndDate = this.formatDate(this.endDate);
      this.getReconciliationsList= [...this.getReconciliationsStoreList]
      this.filteredData = this.getReconciliationsList.filter(item => item.bill_date >= formattedStartDate && item.bill_date <= formattedEndDate)
      this.getReconciliationsList = [...this.filteredData];
    }
    else{
      this.getReconciliationsList= [...this.getReconciliationsStoreList]
    }
  }

  formatDate(date: Date): string {
    return this.datePipe.transform(date, 'yyyy-MM-dd')!;
  }

  // downloadExcel(){
  //   const formattedData = this.formatDataForExcel(this.getReconciliationsList);
  //   const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(formattedData);
  //   const wb: XLSX.WorkBook = XLSX.utils.book_new();
  //   const colWidths = this.calculateColumnWidths(formattedData);

  //   // Set the column widths
  //   ws['!cols'] = colWidths.map(width => ({ wch: width }));
  //   XLSX.utils.book_append_sheet(wb, ws, 'ReconciliationsList');
  //   XLSX.writeFile(wb, 'getReconciliationS List.xlsx');
  // }

  formatDataForExcel(data: any[]): any[] {

    const formattedData = data.map(reconciliations => ({
      'TY': reconciliations.ty,
      'Doc No': reconciliations.doc_no,
      'Post Date':reconciliations.post_date,
      'Bill No':reconciliations.bill_no,
      'Bill Date':reconciliations.bill_date,
      'Assignment':reconciliations.assignment,
      'Debit':reconciliations.debit,
      'Credit':reconciliations.credit,
      'Balance':reconciliations.balance,
      'Description':reconciliations.description,
      'Vendor Code':reconciliations.vendor_code,
    }));
    return formattedData;
  }

  downloadExcel() {
    const formattedData = this.formatDataForExcel(this.getReconciliationsList);
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(formattedData);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const colWidths = this.calculateColumnWidths(formattedData);

    // Add the sum row at the end
    const totalRow = this.calculateTotalRow(this.getReconciliationsList);
    XLSX.utils.sheet_add_aoa(ws, [totalRow], { origin: -1 });

    // Set the column widths
    ws['!cols'] = colWidths.map(width => ({ wch: width }));
    XLSX.utils.book_append_sheet(wb, ws, 'ReconciliationsList');
    XLSX.writeFile(wb, 'getReconciliationS List.xlsx');
  }

  calculateTotalRow(data: any[]): any[] {
    const totalDebit = data.reduce((sum, reconciliation) => sum + (parseFloat(reconciliation.debit) || 0), 0);
    const totalCredit = data.reduce((sum, reconciliation) => sum + (parseFloat(reconciliation.credit) || 0), 0);
    const totalBalance = data.reduce((sum, reconciliation) => sum + (parseFloat(reconciliation.balance) || 0), 0);

    return [
      'Total', // First cell in the row, can be used as a label
      '', '', '', '', '', // Empty cells for other columns
      totalDebit,
      totalCredit,
      totalBalance,
      '', '', // Empty cells for remaining columns
    ];
  }


  calculateColumnWidths(data: any[]): number[] {
    const colWidths: number[] = [];
    const keys = Object.keys(data[0]);

    keys.forEach((key, colIndex) => {
        let maxWidth = key.length;
        data.forEach(row => {
            maxWidth = Math.max(maxWidth, row[key] ? row[key].toString().length : 0);
        });
        colWidths[colIndex] = maxWidth + 2;
    });

    return colWidths;
  }

  calculateTotals() {
    this.totalDebit = this.getReconciliationsList.reduce((sum, item) => sum + (parseFloat(item.debit) || 0), 0);
    this.totalCredit = this.getReconciliationsList.reduce((sum, item) => sum + (parseFloat(item.credit) || 0), 0);
    this.totalBalance = this.getReconciliationsList.reduce((sum, item) => sum + (parseFloat(item.balance) || 0), 0);
  }

}
